import {callApi} from '@/api/apibase'

export const createOrder = function (locationId, productId, greenCourseId, isCourseExtension) {
    const requestData = {
        locationId: locationId,
        productId: productId,
        greenCourseId: greenCourseId,
        IsCourseExtension: isCourseExtension
    }
    return callApi( 'POST','/api/shop/externalsystem/order/createFromExternalGreenCoursePortal', requestData)
}

